module.exports = __webpack_public_path__ + "img/01.078c319c.jpg";